export default __webpack_public_path__ + "2c8564d12b1d9e00cb954b03b2190e16.svg";